module.exports = __webpack_public_path__ + "img/score20.e8a2e97c.png";